import { SHARED } from 'shared/helpers/constants/sharedConstants';

const FIELD = {
  UNIQUE: `(must${SHARED.NON_BREAKING_SPACE}be${SHARED.NON_BREAKING_SPACE}unique)`,
};

export { FIELD };
